import { queryOptions } from '@tanstack/react-query';
import { service } from '@maia/broker';

export function getTeams() {
  return queryOptions({
    queryKey: ['teams'],
    queryFn: () => service.getTeams(),
  });
}
